import { render, staticRenderFns } from "./FarmAs.vue?vue&type=template&id=b37b4e3a&"
import script from "./FarmAs.vue?vue&type=script&lang=js&"
export * from "./FarmAs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports